import ProductsApi from './products-api';

export default ProductsApi;
